import { Filters, ParentVisibility } from "consts/filters";
import { ApiState } from "infrastructure/api";
import { Option } from "util/option";
import { GeneralState } from "./types";

const state: GeneralState = {
  isSideMenuOpen: true,
  notifications: [],

  constants: {
    CsvSettlementStatus: [],
    TransactionFundStatus: [],
    TransactionPayoutStatus: [],
    TransactionStatus: [],
    Currencies: [],
    TransactionCurrencies: [],
    PSPs: [],
    TransactionSettlementStatus: [],
    Via: [],
    MerchantPayoutCalculationEnums: [],
    MerchantPayoutIncrementEnums: [],
    MerchantPayoutIncrementTaxName: [],
    MerchantPayoutIncrementTaxRefColumnsFrom: [],
    MerchantPayoutFileTaxName: [],
    MerchantPayoutIncrementsVia: {},
    KYCStatusEnums: [],
    KYCStatusesMap: [],
    SamePersonIdentifierSourceTypes: [],
    ObResultStatuses: [],
    CardIssuer: [],
    MerchantGroupName: {},
    MerchantGroupNames: [],
    PayoutCycle: {},
    PayoutCycles: [],
    AccountWithdrawalOptions: [],
    MerchantMethodPivotActiveDomainOption: [],
    MerchantPayoutIncrementExchangeRateActiveDomainOption: [],
    TransactionDirections: [],
  },
  bitsoBanks: null,
  userPreferences: {
    preferences: {}
  },
  constantsLoadingState: ApiState.Idle,
  userPreferencesLoadingState: ApiState.Idle,
  bitsoBanksLoadingState: ApiState.Idle,

  // Additional auxuiliary definitions
  extras: {
    [Filters.parentVisibility]: [
      Option.make(ParentVisibility.Children, 'only children'),
      Option.make(ParentVisibility.Parents, 'only parents')
    ]
  },

  countries: [],
  countriesLoadingState: ApiState.Idle
};

export const sliceToken = 'general';

export default state;
